(function($) {
  $('.mfp-inline').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    removalDelay: 200
  });

  $('.mfp-image').magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
    removalDelay: 200
  });

  $('.mfp-gallery').magnificPopup({
    delegate: 'a',
    type: 'image',
    gallery: {
      enabled: true,
    },
    mainClass: 'mfp-fade',
    removalDelay: 200
  });

  $('.mfp-iframe').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade-up',
    removalDelay: 500
  });
})(jQuery);